import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = { url: String, currentClientId: String };

  connect() {
    this.lastClientId = this.currentClientIdValue;
  }

  change(event) {
    const clientId = String(event.detail?.clients?.[0]?.id ?? '');
    if (clientId === this.lastClientId) {
      return;
    }
    this.lastClientId = clientId;
    this.#sync(clientId);
  }

  #sync(clientId) {
    new FetchRequest('patch', this.urlValue, {
      query: { client_id: clientId },
      responseKind: 'turbo-stream',
    }).perform();
  }
}
